<template>
  <div
    class="crm-sale-data-team-sale-rank"
    @click="jumpCustomerSaleRanking"
  >
    <div class="title">
      <span>客户采购排名</span>
      <van-icon
        class="icon"
        name="arrow"
      />
    </div>
    <histogram-transposed-chart
      ref="histogramTransposedChart"
      :config="config"
      :data="list"
    >
    </histogram-transposed-chart>
  </div>
</template>

<script>
import HistogramTransposedChart from '@/views/crm/charts/histogram-transposed';
import setHeaderMixins from '@/mixins/set-header';
import { getSaleRank } from '@/api/crm';
import NP from 'number-precision';
import { cutNumber } from '@/utils/number';

// 客户销售排行版
export default {
  name: 'CrmSaleDataCustomerSaleRank',
  components: {
    HistogramTransposedChart,
  },
  mixins: [setHeaderMixins],
  data() {
    return {
      list: [],
      config: {
        xKey: 'title',
        yKey: 'value',
        color: '#B6CCFC',
        unit: '万',
      },
      form: {
        timeType: '', // 时间类型 -1:指定日期 0:全部 101:实时 102:天 201:周 301:月
        startDate: '', // 开始日期
        endDate: '', // 结束日期
        searchUserId: '', // 搜索用户id
        searchDepartmentId: '', // 搜索部门id
        purchaserCode: '', // 采购商code
        searchType: '', // 选择的人员类型
      },
    };
  },
  watch: {
    $route() {
      // 监听 URL 改变, 重新获取查询参数, 并且发起请求
      // 修复 APP 因为缓存更改URL, 而 vue 的 this.query 不会重新获取导致类型没有更改
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    // 跳转客户销售排行版
    jumpCustomerSaleRanking() {
      window.JSBridge.invoke({
        bridgeName: 'jumpCustomerSaleRanking',
        data: this.form,
        callback: () => {},
      });
    },
    init() {
      const { query } = this.$route;
      const {
        financialType = '1',
        timeType = '101',
        startDate = '',
        endDate = '',
        searchUserId = '',
        searchDepartmentId = '',
        purchaserCode = '',
        searchType = '',
      } = query;
      this.form = {
        financialType,
        timeType,
        startDate,
        endDate,
        searchUserId,
        searchDepartmentId,
        purchaserCode,
        searchType,
      };
      this.getData();
    },
    getData() {
      getSaleRank(this.form)
        .then((res) => {
          let data = res.data || [];
          data = data.reverse();
          const len = data.length;
          this.list = data.map((item, index) => {
            const {
              title,
              value,
            } = item;
            return {
              value: Number(cutNumber(NP.divide(value, 10000), 1)),
              title: `${len - index} ${title}`,
            };
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .crm-sale-data-team-sale-rank {
    background-color: #ffffff;
    padding-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 44px;
      line-height: 44px;
      margin-top: 10px;
      color: #333333;
      font-size: 16px;
      padding: 0 10px;
      .icon {
        color: #999999;
      }
    }
  }
</style>
